function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
export var RegionURLMapper = /*#__PURE__*/ function() {
    "use strict";
    function RegionURLMapper() {
        _class_call_check(this, RegionURLMapper);
    }
    _create_class(RegionURLMapper, null, [
        {
            key: "mapUrl",
            value: function mapUrl(url) {
                var urlPattern = /^https:\/\/api-(\w+)(?:\.dev)?\.nexmo\.com\/v1\/vcr\/api\/(\w+)(.*)$/;
                var match = url.match(urlPattern);
                if (!match) {
                    return url;
                }
                var _match = _sliced_to_array(match, 4), region = _match[1], service = _match[2], remainingPath = _match[3];
                var isDev = url.includes(".dev.");
                var regionMapping = this.regionMappings[region];
                if (!regionMapping) {
                    return url;
                }
                var serviceName = this.serviceMappings[service];
                if (!serviceName) {
                    return url;
                }
                var envSubdomain = isDev ? regionMapping.dev : regionMapping.prod;
                return "https://".concat(serviceName, ".").concat(envSubdomain, ".runtime.vonage.cloud").concat(remainingPath);
            }
        }
    ]);
    return RegionURLMapper;
}();
_define_property(RegionURLMapper, "regionMappings", {
    apac: {
        dev: "qa",
        prod: "apac"
    },
    eu: {
        dev: "qa",
        prod: "eu"
    },
    us: {
        dev: "qa",
        prod: "us"
    }
});
_define_property(RegionURLMapper, "serviceMappings", {
    assets: "vonage-assets",
    deployment: "deployment-api",
    marketplace: "marketplace-api"
});

//# sourceMappingURL=api-routes-mapper-region.js.map